module.exports = __webpack_public_path__ + "media/images/message-40d5ff4d6736905b69bc15ed9d6011d4.png";